import { useSuspenseQuery } from '@tanstack/react-query';
import { getDischargePlansBySignatureOptions } from '@generated';
import { SectionCard } from '~/shared/section/SectionCard';
import { DischargePlan } from './DischargePlan';
import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { DisciplineDischargePlan } from './DisciplineDischargePlan';

export function PlanOfCareDischargePlans({ signatureId }: { signatureId: string }) {
	const { data: dischargePlans } = useSuspenseQuery(getDischargePlansBySignatureOptions(signatureId));

	if (!dischargePlans || (!dischargePlans.dischargePlan && dischargePlans.disciplineDischargePlans.length === 0)) {
		return null;
	}

	return (
		<Section header={<SectionTitle title="Discharge Plans" />}>
			<div className="grid grid-cols-1 gap-3">
				{dischargePlans.dischargePlan && (
					<DischargePlan dischargePlan={dischargePlans.dischargePlan} estimatedDischargeDate={dischargePlans.lastVisitInCertPeriodDate} />
				)}
				<div className="grid grid-cols-3 gap-5">
					{dischargePlans.disciplineDischargePlans.length > 0 && (
						<div className="col-span-3">
							<SectionCard title="Discipline Specific Goals">
								<div className="space-y-1.5">
									{dischargePlans.disciplineDischargePlans.map(x => {
										return <DisciplineDischargePlan key={x.disciplineId} dischargePlan={x} />;
									})}
								</div>
							</SectionCard>
						</div>
					)}
				</div>
			</div>
		</Section>
	);
}
